import React, { createContext, useContext, useState } from 'react';
import { Link} from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // Check localStorage when the app loads
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
      });
    

    const login = (email, password) => {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/login_firebase`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: email,
              password: password,
            }),
          });

          if (!response.ok) {
              throw new Error('Network response was not ok');
          }

          const data = await response.json(); // Process the response to JSON
          const token = data.data.token; // Now you can access token here
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify({ email }));
          setUser({ email }); // Or other user info
          resolve(); // Resolve the promise on successful login
        } catch (error) {
          console.error("Login failed:", error);
          reject(error); // Reject the promise on failure
        }
      });
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
       
    };

    const contextValue = {
        user,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};


export const useAuth = () => useContext(AuthContext);
